import { render } from "./CosmosLoading.vue?vue&type=template&id=a8331390&scoped=true"
import script from "./CosmosLoading.vue?vue&type=script&lang=js"
export * from "./CosmosLoading.vue?vue&type=script&lang=js"

import "./CosmosLoading.vue?vue&type=style&index=0&id=a8331390&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8331390"]])

export default __exports__